import $ from 'jquery';

const chartSliderInit = () => {
  const windowWidth = window.innerWidth;
  if (windowWidth >= 1025) {
    $('.chart__slider:not(.slick-initialized)').slick({
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow: $('.chart__arrows .arrow-left'),
      nextArrow: $('.chart__arrows .arrow-right'),
    });
    $('.chart-tables--mobile.slick-initialized').slick('unslick');
  } else {
    $('.chart-tables--mobile:not(.slick-initialized)').slick({
      dots: false,
      arrows: true,
      prevArrow: $('.chart__arrows .arrow-left'),
      nextArrow: $('.chart__arrows .arrow-right'),
    });
    $('.chart__slider.slick-initialized').slick('unslick');
  }
};

document.addEventListener('DOMContentLoaded', () => {
  chartSliderInit();
});

window.addEventListener('resize', () => {
  chartSliderInit();
});
